import cn from 'clsx';

import css from '../styles/filters.module.css';

interface FilterLabelProps {
  title: string;
  count?: number;
}

const FilterLabel = ({title, count}: FilterLabelProps): JSX.Element => {
  return (
    <div className={css.filterLabel}>
      <div
        className={cn(css.filterLabel, {
          [css.disabledLabel]: !count && count !== undefined,
        })}
      >
        {title}
      </div>
      {Boolean(count !== undefined) && (
        <div className={css.filterCount}>{count}</div>
      )}
    </div>
  );
};

export default FilterLabel;
